document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-collection-card').forEach(card => {
    card.addEventListener('click', (e) => {
      if (e.target.closest('a, button')) return;

      const url = card.dataset.url;
      if (url) window.location.href = url;
    });

    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'link');

    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const url = card.dataset.url;
        if (url) window.location.href = url;
      }
    });
  });
});
